export default __webpack_public_path__ + "static/media/icon-phone.01831b81.svg";